/* unplugin-vue-components disabled */import script from "./RoleSwitchDialog.vue?vue&type=script&setup=true&name=RoleSwitchDialog&lang=js"
export * from "./RoleSwitchDialog.vue?vue&type=script&setup=true&name=RoleSwitchDialog&lang=js"

import "./RoleSwitchDialog.vue?vue&type=style&index=0&id=5675283b&lang=scss&scoped=true"
import "./RoleSwitchDialog.vue?vue&type=style&index=1&id=5675283b&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5675283b"]])

export default __exports__